import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import styled from "@emotion/styled"

const Intro = () => {
  const data = useStaticQuery(graphql`
    query AboutIntro {
      craft {
        entries(section: "about") {
          ... on Craft_about_about_Entry {
            introduction
            aboutOpeningSection
            image: profilePhoto {
              title
              url(width: 1400, quality: 100, immediately: true)
            }
            imageFile {
              childImageSharp {
                fluid(maxWidth: 800, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
                }
              }
            }
          }
        }
      }
    }
  `)

  const about = data.craft.entries[0]
  const profilePhoto = about.imageFile[0]
  const profileAlt = about.image[0].title
  const deskPhoto = about.imageFile[1]
  const deskAlt = about.image[1].title

  const IntroContainer = styled.section`
    display: block;
    padding-top: 5.5rem;

    @media (min-width: 46rem) {
      padding-top: 15rem;
    }
  `

  const ImagesWrapper = styled.section`
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1873 913'%3E%3Cdefs/%3E%3Cdefs%3E%3Cstyle%3E .cls-2%7Bfill:%23f6bdbb%7D %3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Website'%3E%3Cg id='About'%3E%3Cpath fill='%232a4b9b' d='M4 138c-3 11-5 23-3 29 3 10 10 18 18 25 21 20 48 32 77 32 34 0 55-18 81-37 14-9 30-14 43-24 15-12 26-28 34-46 8-16 18-33 19-51 1-11-3-23-9-34-15-25-31-34-60-32-41 4-83 13-116 37-20 14-35 32-50 50-9 12-21 21-28 34a111 111 0 00-6 17z'/%3E%3Cpath d='M270 898c-38 21-80 23-117-20-26-31-19-81 5-114s60-55 93-79c21-15 41-32 48-57 7-24-2-50 2-74 5-29 25-52 48-69 37-28 86-44 129-28s72 69 50 109c-14 26-44 40-56 66-12 24-6 54-12 80-14 55-76 82-114 124-21 22-47 47-76 62zM1559 284a47 47 0 00-11 30c-1 12 4 25 11 35 15 22 37 39 58 54 31 23 67 41 92 71 29 34 45 117 102 114 54-3 64-85 62-126-3-36-14-72-26-107a613 613 0 00-26-60c-7-14-16-27-30-34-20-11-47-9-69-11-28-3-56-5-83-2-26 3-62 14-80 36z' class='cls-2'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    position: relative;
    margin-top: -5rem;

    @media (max-width: 46rem) {
      padding-left: 0;
      padding-right: 0;
    }

    @media (min-width: 46rem) {
      margin-top: -1.5rem;
      background-position: top center;
    }

    &:after {
      @media (min-width: 46rem) {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 676 658'%3E%3Cdefs/%3E%3Cdefs%3E%3Cstyle%3E .cls-3%7Bfill:%233c3c3b;fill-rule:evenodd%7D %3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Website'%3E%3Cg id='About'%3E%3Cpath fill='%23fff' d='M55 559c-13 6-24 17-29 35-8 31 22 58 51 63 19 4 69-4 80-21 3-3 3-7 4-11 1-16 0-32-8-45-18-30-70-35-98-21z'/%3E%3Cpath fill='%23f8dd4e' d='M2 359a201 201 0 0049 71c11 11 24 20 39 25 22 6 45 1 67-7s40-21 61-30c29-12 62-18 93-13 26 3 52 15 72 33 12 11 22 27 31 41 8 12 17 23 29 29 50 24 66-50 70-83 5-48 32-96 75-116 22-10 47-14 65-29 26-20 30-61 12-88s-56-39-87-28c-16 5-29 15-44 23a166 166 0 01-127 11c-15-5-30-13-39-26-7-11-9-26-10-40 0-23 4-47 1-71s-14-48-36-57c-21-9-46-1-62 14s-26 37-31 59-9 44-15 66c-18 64-68 119-131 143-18 7-38 11-54 21s-31 28-30 47z'/%3E%3Cpath d='M381 136c0 1-3 2-3 0h2c-1-1-2 0-2-2l3 2zM440 114l-2-1c1-1 2 0 2 1zM425 171c2 1-2 2-3 4 0-2 3-3 3-4zM405 196c2 0 0 2 2 3-3 0-1-1-2-3zM368 229h1c2 0 1 2-1 2a3 3 0 000-2zM361 243c0-1 3-2 3 0h-3zM336 138c-3 1-4-1-6-2 1 3-1 0-3 2-1 4-2 4 0 10 2 0 0-2 2-2l1 2a8 8 0 005-2 2 2 0 01-1-2l2 1v-7zm-7 3c3-1 2 2 4 2-1 2-4 0-4-2z' class='cls-3'/%3E%3Cpath d='M377 121l2 1-1 1 2 2c-2 0-2 2-1 3h2l1 2v1 4l-4-2c-1 2 0 3-3 4 0-1-2-3-2-1-2 1 2-3 2 0 1-2-2-2-2-2a2 2 0 00-1 2c-4-2-1-2-3-5l2-1c-2-1 0-3 0-5 2-1 3 1 3-2l1 2c1-2 3-1 2-4zM399 125c-2 0-2 2-3 1l4-6-1-3-1-1c-2 1-1-1-3-2 0 3-2 2-2 3l-3 4 1 1c-1 1 2 3 0 5 1 0 2-1 1 1 2 0 1-1 2 1v1c0 1 2-2 1 0h2c-2 0 0-4 0-1l2-2a3 3 0 010-2zm-5-4l1 3a3 3 0 00-2 0l1-3zM358 143c-2 1-2-1-3-2 0 1-1 3-2 1v3c-3-1-2-3-5-5a1 1 0 011-2c-1 1-2-1-2-3 3-2 7-1 7 1l2-2c0-1-3 2-3-1 1 1 2 0 1-2 1-1 1 2 3 0v4h2c0 2-1 4 1 5-1 1-4 2-2 3zM434 111c0-1 0 0 0 0 2-1 0-3-1-3 1-2 1-4 4-5 1 2 3 1 5 0 0 3-4 7-2 9-1 1-3-2-3 1-1-1-1-2-3-2zM417 118c0 2 4 2 2 4-2 1 1-2-1-2v3l-3-1 2-1-1-1h-1c0-2-1 0-2-3h2c-2-1-2-1-2-3 2 0 3-3 5-4l2 2c-1 1 0 1 1 2l-3 1 3 1a3 3 0 000 1 3 3 0 00-3 1h2c0 2-2 1-3 0z' class='cls-3'/%3E%3Cpath d='M380 128l2-1c0 2 2 0 2 3-2 0-2-3-4-2zM344 159c0 2 2 0 2 1-2 2 0 3-1 6h1a4 4 0 013 0v-2h1a3 3 0 010 2c3-1 3-3 3-3-1 0-3 0-4-2 2 0 2 2 5 1v-5c-2-1-3 1-4 1h-1l1-3v-1c-2 4-4 2-6 5zm7 0l1 3c-1 0-2-2-1-3zM388 142v2h3-2v-2l2 1c1-2 2-2 1-4h2l3 8-2-2c-1 1 1 3 2 4-2-2-3 3-5 2 1-1 0-1-2-2-1 1 0 1 1 3-1 0-3-1-2-2a2 2 0 00-1 2c-1 0-1-2-2-1v-1s2-2 0-2h1l-1-3c-1-2 2 0 1-2l1-1zM389 152l2 2a8 8 0 01-4 0c0-1 0-2 2-2zM371 149c1 1 3 1 2 2v-1c3-2 0 3 3 2 0 2 0 1-1 1 1 1 2 2 1 3l1 2h-3c0 2 0-1 1-1 0-1-2 0-1 1 0-3-3-2-6-3v-4l2 1c2-1 0-1 0-2 1-1 1 2 2 1a3 3 0 01-1-2z' class='cls-3'/%3E%3Cpath d='M369 155v1h2c1 1-1 2-2 2l1-1h-2l1-2zM438 134c-1 1 1 2-1 3v-4l-2 2 1 2c-1 1-2 0-2-1v-3 1l-1-1a3 3 0 01-1 1v-2c-1-1-1 1-2 1l1-2c-1 0-2 1-2-1 0-3 4-2 3-5l2 1c0 1-2 1-1 2 3 1 4-5 7-3 1 1-1 1-1 2h1c2 2 0 2 2 5-2-1-1 3-2 0-1 0 0 3 1 1v2c-2-1-2 1-3-1z' class='cls-3'/%3E%3Cpath d='M433 135v2c-1-2-2-1-3-2 2-3 0 2 3 0zM343 176l-2-3s1 0 0 0l-2 3 3 3h-2c2 2 0 4 2 4-3 2 0 1-1 3 2 0 0 1 2 2l6-3c0-2-2 0-2-2h3l-2-2a3 3 0 012 0c-1-1-2-3-4-3l2-1-3-4c1-1 2 0 1-2h-2c0 1 0 3-1 2-1 1 2 2 0 3zm3 10v-1l-1-1c1-2 3 2 1 2zM387 159l-1 1c1 1 2-1 1-3 0-2 2 3 2 0l2 1v1c0 1 0 0 0 0l-2 4h2c2 2 1 4 0 7a4 4 0 00-4 1l1-2c-2 0 0 2-3 2 0-1 2-3-1-2 2-2 2-1 2-4-2 0 0 2-2 3 0-2 2-3 3-4-3 1-2-4 0-5zM370 167l-3 3c-2-2-6 0-7 3 1-1 1 0 1 1l1-1c-2 1-1 4-1 5 2-1 4 3 4 2 0-2 2-1 2-3h1c-1-2-3 0-3 1v-3l5 2c0-2 2 0 2 0 0-3 3-4-1-5l2-1c-1-2-4-1-2-3a2 2 0 01-1-1zm-6 6c1-1 2 1 2-1 2 0 0 2 0 2l-2-1zM430 149a2 2 0 002-1c2-1 1 2 3 1v1h-2c2 2 2 1 4 1 0 2-1 2 1 4-2-1-2 2-4 1v1 2h-2c-1-1-3-2-4 0 0-2 0-5-2-7 1-2 3-2 1-5 1 0 4 0 3 2zM412 158v-1c2 0 1-2 3-2l2 3c-2 0-2 2-3 1v2c2 0 1-1 2-2 1 2-2 3-1 5l1-2c2 2-2 2 0 4-2-1-4 3-4 3-1 1-1-3-4-4-1-2 3-4 1-5 0 0 3-3 3-1l1-1a2 2 0 00-1 0zM455 144v-2c2 2 1 3 2 5l-1-1-2 1s-1 3 1 2c1 2-1 0-2 1v-3c-1-1-2 0-3-2 0 2 5 3 1 5l1-1c-1-1-3 2-1 3 0 1-2-2-3 0l-1-1a20 20 0 003-1l-2-1v1c-1 0-2-1-1-2 2 1 0-3 1-5l2-1 2 1a2 2 0 003 1zM406 186l2-3-3-2c-1 1 0 3-2 3l1-1v-3h-2c0-1 2-4 3-1 2-2 0-2 0-3a4 4 0 01-2 2c0-1 2-1 0-3 3 2 1-3 4-2a4 4 0 01-1 2c2 1 3-1 5-1v5c-2 1-3 5 0 5l-5 2zM356 197c-3-2 1-1 3-2-3 0 0-1-2-2l2 1c1-2 3-2 4 0v-3c1 1 2 2 2 0 3 3 1 6 1 9a3 3 0 01-2-1c-1 1 1 1 1 2a1 1 0 01-2-1c1 2 0 3-1 4-2 1-2 0-2-2-1 1 0 2-2 2 1-1 0-2-1-2 0 0 5-1 6-3 0 0-3-1 0-2-3 0-3 2-3 2-2-1-2 2-5 3-1-2 1-3 2-4-1 0-2-1 0-1h-1zM382 185l-3 2c1 0 3 1 2 2-2-2-3 0-5 1 1 0 2 1 0 1 1 2 2 1 3 2l-3 1c1 2 4 1 3 4h1c3-1 2-2 6-2v-1a2 2 0 01-2 0c2-1 1-3 3-3-3-2-7-4-5-7zm-3 9l1 1c1-1 4 0 2-2 4 1-1 3-2 4l-1-3zM437 172l-2 1c0-2 0-1-2-3 2 1 4-1 2-2v-1l-3 1v-2c-3-1-3 3-5 5a2 2 0 013 0l-8 4a4 4 0 002 4l-1-2c2 0 2-2 3-1-1 1-3 3-1 4l1 2 2-1c0 1-1 4 1 4a1 1 0 011-2l-1-3 2 5c2-1-1-2 1-4 1 1 3-1 4-1l-1-1c3-2 1-5 2-7zm-1 6l-2-2 2-1c2 0-1 2 0 3zm-7-3c-1-1 0-2 2-3l1 2v-1h1v1c-2 1-2-1-4 1zm4 1v3c-3 2-2-2-5-1l4-3 2 1h-1zM447 173l1 1c2 0 5-2 3-3 1-2 2-2 3-1v-1-1a2 2 0 01-2 0c3-1 1 0 0-2 1-1 2 0 3-2h-1v-1c-3 2-3-2-4-2l-4 2a11 11 0 010 4v1c1-1 3-2 4 0-3 0-3 0-3 2l-1-1h-1l1 3c1 0 1-2 2-1a4 4 0 00-1 2zm2-2s0 2 1 1c-1 3-4-1-1-1z' class='cls-3'/%3E%3Cpath d='M384 187v1h1v2c-2 0-3-3-1-3zM353 217c-1-1 3 1 2-1a1 1 0 011 1h2l-1-2v1c-1-1-2 0-3 1 0-4 2-5 5-4 1-1-2-1-1-2a6 6 0 013 2c-2 1 0 1 0 2l-3-1c0 1 3 1 1 3 1 1 1-2 3 0v-4c1 1 2 3 4 3-1 1-4 0-2 4l-2-2c0 1 0 2-2 1 1 2 3 1 4 2-2 0-5 0-8 3l1-3c-1 1-1 3-3 1-1 0 0 2-2 2 1-1 0-2-1-1l3-2c-1-1-3 1-2-1 2 1 1-1 3-2l-2-1zM401 196c0-1 2 0 1-2h4l-3 2c1 3 2 5-1 6v-2c-2 0 0 2-2 3h3v2c-1 0-2-2-2 1l-2-4-2 3-1-2-3 3c-2-3 3-5 3-4h2l-3-2h3c2-1-1-2-2-1l3-3 1 3 3-2a2 2 0 00-2-1zM425 190v3c-2-1-2 0-2 1-3-1 0-3 2-2-1-2-3-1-4-2-1 1 2 0 1 2-2 0-1 0-1 2l-1-1a2 2 0 00-1 2h4l-1 3-2-2v2h4l1 1c-2 1-3 0-5 2-2-1-1-2-3-2 1-2-2-3 1-5 0-2-2 0-2-2l3-3c2 1 1-2 3-1 1 2 0 2 3 2zM442 192a3 3 0 012 0c1-1 0-5-1-4 2 0-1 4-2 2 3-2-1-1-1-1 2-1 1-2 3-2-3-1-5-1-3 1-3 0-1-4-4-4l-1 3h2c-2 0-2 2-2 3 2-1 1 1 0 1 2 0 1 1 2 2a3 3 0 01-2 0c2 1 0 3 1 3l1-1a4 4 0 00-1 2l1 1c2 0 1-3 2-2v1l2 2 2-3c-3 0 2-4-1-4zm-1 0h-3c0-2 2-1 3 0zM382 207v3c-2 0-1-3 0-3zM458 178h1v2l2-1c1 2 1 1 2 0l1 2-3 1h3l-1 5c-1 2-2-1-3-1l2-2c-1-2-3-1-4-1l-2-4 2-2v1zM377 214c0-2-1-3-2-3 1 2 0 2-1 3 0 1 2 3 0 3 1 1 3 0 1 2 3 1 1 1 2-1l1 2 1-1-1-2c2 1 2 0 2-1v2h3c-2-2-1-3 0-4-1 0 0-3-3-3 1 3-3-1-3 1 1-1 3 1 2 1-1-1-1 0-2 1zm-2 1h0z' class='cls-3'/%3E%3Cpath d='M393 207l3-2 1 2a4 4 0 001-2h1c2 0-1 1-1 3l-2 1c0-1-1-3 1-2l-2-1c0 1 0 2-2 1zM371 230v1c-1 1-3 0-5 2l-2-3v1c-1-2-1 1-2 1l-1-2-2 3c1 0 4 0 2 2l-1-1-1 1-1-1c-2 1-3 4-1 6l-1 1 1 2c4-1 6-2 10-1-2-3 2-1 0-3a4 4 0 003 0c0 1 0 2 1 1h1v-3a2 2 0 011 1c4-1 0-1 4-3 0-2 0-6 3-6-1 0-3-3-2-4l1 1a4 4 0 00-1-3c-2 1-1 3-2 4l-4-1a1 1 0 01-2 2c1 2 0 3 1 2zm1-3c2 1 4 0 4 3-1-2-3 0-3 1-2-2-1-2-1-4zm-8 8c2 1 2 3-1 2h4c1-1-4 3-1 4a9 9 0 01-4-4c0-2 2-1 2-3h1l1 1h-2zM458 198l1 2h2c-2-3 4-4 3-7a13 13 0 014-1c-1 1-2 4 1 3l-1-1c2-1-1 2-4 2l1 2 1-2c1-1 0 3 3 2-1 0-2 2-1 3 1 2-2-2-1 0-2 1 0-1 0-2-1 2-3 4-2 5l-1-2v3c-3 2-3 2-7 1-2-1 2 1 2-1 0 0 0 2 2 0-2-1-2-1-2-3-1 2-1 0-2 1l-1-1c0-2 1 0 2-1-2 0 1-2 0-4h2l-2 1zM433 213c-1 0 2-2 0-3h4c1 0-5 1-4 3z' class='cls-3'/%3E%3Cpath d='M440 207c-3 0-2-3-5 0 1-1 3 1 2 2-1-1-1-2-3-1 1 2 3 0 4 2l-1 1c-2 0-5 3-3 4v2c3 1 6-3 6 0 2-1-1-5 3-5l-2-2h-2a8 8 0 011-3zm-5 6c2-1 1 0 1 1l2-2c2 0 1 0 1 2 3 0-1 0-2 1l-2-2z' class='cls-3'/%3E%3Cpath d='M439 206l2-1c1 1 0 2-1 2h2l1 2c1 2-3-3-2 1-3-1 1-5-2-4zM410 217l2-1c-1 2 2 2 0 2l1 1v-2c2 0 4-2 6 0 1-1-2-1-2-2 2 0 3 0 3 2l-1 2c2 1 1-3 3-3-2 2 0 3 1 2s-1 2 1 0c-1 3 0 3-5 4v-2c-2-2-3 3-6 3h3a11 11 0 012 2c1-2-1 1 1 1v-2l2-1 2 3a4 4 0 01-5 1c0 1 2 0 2 3-1-1-2 0-3 1a3 3 0 000-2h2l-1-1-4 2c-1-1 1-1 1-2h-3a2 2 0 011-2c-1-1-1 0-3 1 0-3 1-4-2-5 1 0 3-1 3 1l-2-4a2 2 0 012-1l-1-1z' class='cls-3'/%3E%3Cpath d='M423 222c1-1 0 1 1 2-2 2-1-1-2-2h1zM397 225h-1c-4-2 0 5-3 6l1 2c4 1 6-3 7-7-1 0 0 3-1 2 3-4-2-3 1-7l-3 4c0-1-2-3-2-1a2 2 0 011 1zm2 2c2 0-2 3-3 2 0-1 3 0 3-2zM399 126c2-2 3 1 2 2l-2 1c0-1 2-2 0-3zM412 139c1 1 0-3 3-3l1 5c-1 1-2 1-1 3-3 3-5 1-5 2-3-1 0-3-3-4 2 0 0 0 0-1l4-2-1-2 1 1v-3c3 0 1 3 1 4z' class='cls-3'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        width: 55%;
        height: 30%;
        transform: translate(-50%, -50%);
        width: 40%;
        height: 50%;
      }
    }
  `

  const Images = styled.div`
    display: grid;
    grid-auto-flow: dense;
    grid-template-columns: repeat(6, 1fr);
    gap: 2.5rem;
    margin: 2rem auto 0rem;
    padding: 8rem 0;
    width: 100%;
    max-width: 88rem;

    @media (min-width: 46rem) {
      margin: 0 auto;
      padding: 0;
    }
  `

  const ImageContainer = styled.div`
    grid-column-end: span 6;

    @media (min-width: 46rem) {
      grid-column-end: span 3;
      position: relative;
      margin-top: 6rem;
      margin-bottom: 6rem;
    }

    &:first-of-type {
      &:before {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 520 883'%3E%3Cdefs/%3E%3Cg data-name='Layer 2'%3E%3Cpath fill='%233c3c3b' d='M28 689c-18 11-28 34-28 55s9 43 21 61c27 40 85 86 137 76 29-5 55-39 70-63 12-19 21-42 20-66-2-26-19-53-35-73-20-26-57-25-87-23a214 214 0 00-96 31z'/%3E%3Cpath fill='%23e5d7bc' d='M53 42l-3 2a60 60 0 00-24 59c2 11 5 23 10 33 11 21 35 35 59 36 15 0 29-5 44-8a263 263 0 01153 11c24 9 47 22 63 42s24 48 16 72c-8 22-26 39-33 61s-5 50 10 69c24 31 90 38 116 6 12-16 12-38 8-58s-11-39-11-59a83 83 0 0113-44c8-13 21-24 30-36s18-28 16-44c-4-24-28-38-49-52a264 264 0 01-56-50c-13-16-24-32-40-45-20-17-46-26-72-31a251 251 0 00-122 3c-22 5-44 8-67 12-21 4-43 9-61 21z'/%3E%3C/g%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        content: "";
        position: absolute;
        top: 5rem;
        left: -4rem;
        width: 55%;
        height: 43%;
      }
    }

    &:last-of-type {
      &:after {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 184 220'%3E%3Cdefs/%3E%3Cdefs%3E%3Cstyle%3E .cls-1%7Bfill:%23ededed;fill-rule:evenodd%7D %3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Website'%3E%3Cg id='About'%3E%3Cpath d='M57 140l1-1c-1-1-2 1-1 1z' class='cls-1'/%3E%3Cpath d='M184 107h-3v-1a2 2 0 01-2-1v3c0-2-1-2-2-2a2 2 0 012 0c-3-3-1-4-3-5 0-1 1-2 2-1a11 11 0 014-6c-1-1-1 1-2-1l-1 2c0-2 2-1 3-3l1 2 1-2c-2 1-4-2-5 0h1l-2-1c3-1-1 0 0-2a2 2 0 01-1 0l-1 1v-2h-1a15 15 0 01-2 2c0-2-2-2-2-2 1-1 2 0 3 1 0-2-4-2-6-4v1l-2-1a2 2 0 012 0l-2-1v1l-3-1 2-1-3-2-2 1v-2c-1 1-2-1-2-1-4 0-6 4-5 6-2 1-6-1-7-2 1 0 1-2 3-1l-1-3c-1 1-2-2-3 0h1a2 2 0 00-1 1 15 15 0 010-3c-1 1-5-4-8-2a3 3 0 010-1 3 3 0 010-1c0-1 0-1 0 0h-1c-1-3-3-3-4-5-1 1 1 0 1 2h-1c1-1 0 0-1-1l1-2a6 6 0 00-2-1l-1-1c1 2 0 0 1-1 1-2 5-3 3-6h-2c1-4-6-5-8-9-1 2-1-1-2-2l2 1v-2c0 2 2 0 2-1 1-1 1 3 2 1-1 0 1-2-1-1a8 8 0 012-2c1 1 1 3 3 1-2 2 1 0 1 2-2 1-4-2-4 0h1c-3 1-1 2-3 3l-1-1a1 1 0 001-1v-1l-3 1c0 2 4 4 4 2l2 2 1-1s0 1 0 0c-1-1-1 0-1 1-2-1-1-2-1-4h1-1v2h2a2 2 0 000-2h1c-1 1 0 1 1 1l-1 3v1c2 0 1-3 3-1l-1-2c2 1 2-3 3-2l2-4c-2-1-4 1-4-2-3 3-4-1-6-3-1 0 2 1 0 1h-1l1-2c-1 1-1-2-2 0 2 1-1 1-1 2v-2h-1l2-1a3 3 0 00-2 0v-1c-3 1-3-4-5-3l1 2c-1-2-1 0-2 0v-2l1 1v-2c-3 0-3-2-5-1 1-1 0-3-1-3l-1 2 1-2c-2 0-2-2-3-2l-2 3v-3c0 2 2 1 2 0l-10-5-1 1c0-1 0-2-1-1v-1c-1 1-1-2-2-1 1 1-1 2-1 3v-1-1l-1 1c0-1 2-1 2-3h-3a6 6 0 01-3 4l-2-2a1 1 0 010 1v-2a13 13 0 01-5-4c2 1 0-2 0-1 1 1-3 2-4 2l1-2 1 1v1l1-1-1-2c-2 0-2 2-3 3v-1a2 2 0 01-1 1l-1-1a7 7 0 01-2 1c2-1-2 0 0-2-2 0-1 2-2 2a2 2 0 010-3h-2c2 0 0 0 0-1v-1c0 1 0 2-2 3 0-2 2-1 2-4l-3 1V9a2 2 0 002 0l-2-2c-1 2 0-1-2 0v3c0-2-2-2-1-4 1 3 0-1 1-1l2 2c0-2-2-1-1-2h-4a1 1 0 000-2 3 3 0 01-1 1l2-2c0 1 1 3 2 2l-3-3-2 1V0l-2 2c2 0-1 1 1 1a1 1 0 01-2 0c-1 1-2 2-1 3 0-2 2-1 2 0a4 4 0 00-2 0h-1v2h-2v5h-3c1 2-3 2-1 4h1l-1 1c0-2-1-2-1 0-1-1-3 0-1-1h-2c-1 2 2 1 1 3a4 4 0 00-2-2c1 2-3 0-3 2a2 2 0 011 0h1v-1a2 2 0 010 1h-1l-2 1c-1 2 1 1 1 2l-1 2-1-2a2 2 0 011 0h-2c1 0 0 2-1 1 0 3-1 0-2 2a3 3 0 010 2c1 0 3 2 1 3-1-3-3-1-4-3 1 1 1 2 2 0-2 0-2-4-5-2l1 1a2 2 0 00-2-2l-1 4a14 14 0 01-4-6h-2v1c-2-1-2 3-4 3 0 0-1-1-1 1l-3-4c-3 0-2 3-3 2a4 4 0 00-1 4l-2-2c1 1-1 2-2 1v3c-2 0-4 0-2 1H1l-1 3c3 1 2 3 5 5v-1a1 1 0 011 0l-1 3h1l-1-1 2-1v2l1-1v1h1c-1 1 1 0 1 1-3 0 2 2-1 2 1 3 4 5 1 8 0-1 2-2 0-3l-1 3H8v2l-1-1v3c0-1 0-1 0 0H5c2 2 3 5 5 5-1 1 1 3 2 3v1c1-1 0-3 1-2v3h-1l5 5c1-2-1-1-1-3-2 0-1-2-2-2l1-1 1 3h2l-1 1c2-1 0 3 1 2l1-1c-1 1 0 0 1 1l-4 6h1a3 3 0 01-2 0c1 5 4 6 7 9h-1c2 2 2 4 5 4a2 2 0 012 2l-2-2c0 2 2 4 3 5l2-2 1 3-2-2c0 4 5 5 5 11l11 8c0 2 3 4 6 5-1 1 3 6 5 4a6 6 0 002 4 1 1 0 000 1 2 2 0 010-1 16 16 0 012 2l-3-1c0 1 2 1 1 2a6 6 0 014 3l-2 2a1 1 0 012 0h-3a13 13 0 01-3 5c1-2-2 1 0 1l2 3h-2v-1h1l-1-1-1 1c0 2 2 1 3 3h-1a2 2 0 011 1h-1a7 7 0 012 2c-2-1 0 3-2 1 0 2 2 0 2 1a2 2 0 01-3 1c0 1 2 1 1 2-1-2-1 0-1 0h-1l2 1h-3l1 2-1 1a2 2 0 00-1-2l-1 2c2 1-1-1 0 1h3c-1 1-1 2-3 1h-1a11 11 0 011-2l-2 1 1 4a1 1 0 00-3 0 3 3 0 012 1l-2-1c0-1 3-2 2-3-1 2-3 2-3 4l1 1-2 1 3 1c-1-2 1 1 1-1 0 0-1 0 0 0a1 1 0 010 2c0 1 2 2 3 0-2 1-1-1 0-2a4 4 0 000 2v2l2-1v2h5v2c3-1 4 3 5 1l-1-1 2 1c-2 0-1 1 0 0-1 2 1 3-1 2v2c3 0 1-2 3-2a4 4 0 00-1 2c2 0 0 4 2 3a2 2 0 010-1l-1-1a2 2 0 011 1l1 2c2 1 1-1 2-2 0 2 2 1 3 2l-2 1a2 2 0 010-1l-1 2a1 1 0 112 1c3-1 0 0 2 1a3 3 0 012 0c0-1 2-3 3-2-3 2 0 3-2 5v-2c0 2-4 3-2 5l1-1a2 2 0 00-1 2h3a14 14 0 01-5 6l1 2 4 3h1l-3 4c0 3 3 2 2 3a4 4 0 004 0c0 1-2 2-1 3 0-2 1 0 1 1h3c1 1 1 3 1 1l1 2 3 1c1-3 3-2 4-5h-1a1 1 0 010-2l2 1 1-1-1 1c-1-2-1-1-2-1l3-1-1-1h1l-1-1c2 1 0-1 1-1 1 3 2-2 2 1 3-2 5-6 8-3h-3l4 1-1 1h2v1h2v-1 2c2-2 5-4 5-6 1 1 2-1 3-2 0-1-2 1-2-1h3v1l4-6c-2 0 0 2-2 1 0 3-2 1-2 3l-1-1c1-1 3 0 2-1v-2h1l1 1c-1-2 2-1 2-2-1 0 0 0 0 0-1 0-2 1-2-1 1 1 0 0 1-1l6 3v-1a3 3 0 011 2c4-2 5-5 7-8l1 1c1-2 3-3 3-6a2 2 0 011-2l-1 2c2 0 3-2 4-4l-2-1 3-2-2 2c4 0 5-5 10-7 1-4 6-8 6-12 2 0 4-3 4-6 2 0 5-5 4-5 3-1 3-5 5-6a6 6 0 00-3-2l1-1-3-1h3l3-4a3 3 0 010-2c-1 0-3-2-4 0 1-2-3-2-4-3l1-2-2-1 1-1h-1c2 0 2 2 3 1 1-2 3-3 2-5l1 1 1-2c-2 0-3 1-3 2a2 2 0 000 2h-2l1-1-2-1 2-1-1 1h2c0-2 0 0-2-1a6 6 0 013-1l-1-2c2 1 2-2 3-4 0 3 2 2 0 4 1-2-1 0-1 0l1 1 5-7-1 1-1-1c1 2-1 3-2 5v-5l2 1c-2-1 2-4 0-4 1-1 2 0 1-1l2 1c0-2 1-3 2-3v1l1-2zm-51-63l1-1h1a2 2 0 00-1 2h-1c1 2 1 2-1 1 0-1 3-1 1-2zM11 48c0-1-2 0-1-2l1-1c0 1 0 2 2 2a2 2 0 01-2 1zM8 61l1-2v1l-1 1zm2-3c-1-1 1-1 1-2l-1 2c1 0 0 0 0 0zm2 8c-2-3 1-3 0 0zm1-16l-1-1c2 0 1 1 1 1zm9-26a3 3 0 00-1 0h1zm-1 40v-1 1zm3-37c-1 1 0-2-1 0-1-2 2-2 1 0zm9 4c1-2 3 0 0 0zm11-10a2 2 0 000-2l1 1a2 2 0 01-1 1zm5 2l-2-1h2v1zm1-7a2 2 0 011-1c1-2 0 1-1 0v1zm5-4l-2-2c1 0 3 0 2 2zm5 127c-1 0 0 2-2 2a4 4 0 012-2h1v1l-1-1zm-4 19l2-1-2 1zm2 14c0-1 0-3 2-2l-2 2zm3-20l-1-1 1-1v2zm1-13a2 2 0 00-2-1l1-1v1l1-1v2zm15 62h1a3 3 0 00-1 0zm2-2c0 1-1-2 1-1 1 0-2 0-1 1zm31-55v0zm11-65h-1v-1l-1 1-1-1a5 5 0 010-1h-1c-3-4-9-7-11-11 1 1 3 1 3 3l2-1-1 1 11 10zm-7-39c1-3-1 3 0 0zm6 2v2l-1-2h-1c0-1 2 1 2-1zm-2 1c2 2 0 1-1 0h1zm4 37l1 1a2 2 0 01-1-1zm-17-15h0zm15-19l1-1v1l1-1-1-3 2 4h-3zm4-3c0-2 0 1 1 1-1 2-1-1-1-1zm3-3l3 2a2 2 0 01-1 2v-2l1 1-3-1a2 2 0 000-2zm0-2l-1 1 1-1zm0 5l-2 1v-1c1-1-1-1-1-2l3 2zm-3-5l-1 1c0 2 1 0 2 1h-1v2l-1-2c-1 0 0 2-1 1 0-1 0-2 2-3zm-2-1l-1-3 2 2c-1 0-1 2-3 2-1-2 1-1 2-1zm-2 2h-1v-1c1-1 1 2 1 0zm0 2l-2 1 1-1c-2 0-1-1-1-2l2 2zm-4-8c1-1 2 1 2 2l-1-1c-1 1 0 3-1 2 0 2 1 0 2 2-2-1-3 2-4 0h2l-1-3c1 0 2 0 1-2zm-3 3l2-2c0 1-2 1 0 1-1 1-2 2-3 1h1zm-1 1c1-1 0 2 1 1l-2 1 1-2zm-1 0l-1-1c-1 0 2-2 1 1zm-4-12l-1-1c0-1 1 2 1 0 2 2-1 2-1 1h1zm-2 3h2l-2 1 5 1v1h-1l-2-1a1 1 0 00-1 1c-1 0 0-2-1-1v-1-1zm1 4l-2-1 2 1zm-5-11l2 3c-1 0 0-2-2-1l1 1h-1v-3zm0 6c1 0 0 0 0 0l2 1c1 0-2-1-1 1 0 2-1-2-1-1v-1zm-1-6c2 0 0 1 1 2l-1-1h-1l1-1zm-2 2v-2 2zm-1-3v-1 1zm-10-2h-1l1 2-2-1a2 2 0 001-1h1zm-3-3a4 4 0 012 2l-1 2v-1-1c0-1-2 0-1-2zm-12 1l2-1 1 1h-3zm-1 49h0zm-3-53l-1-1 1 1zm-4 162a2 2 0 01-1-1l1 1c1-2 1-2 0 0zm5 5l1-1 1 1a2 2 0 00-2 0zm2-3v-1-1h1l-1 2zm11 13c-2-1 0-4 0 0zm19 20l-1-1c1-1 2-1 2-3l1 2-2 2zm2-3c0-2 1-1 2-1l-2 1zm6-61h1a1 1 0 01-1 0zm4 62l-2-1h2v1zm1 0h1l1 1-2-1zm3-12h-1 1zm3 9c-2 1-3-2 0 0zm25-123l2 1-2-1zm9 2v-2 2zm19 53l2 1v-1c1 1-2 3-3 4l1-4zm-2-10l-1 2 1-2zm2-7h-2l1-1h1c2 0 0 1 0 1zm3-11c0-2 0-1 1 0h-1z' class='cls-1'/%3E%3Cpath d='M100 211h-1v1h1c0-1 2-1 1-2s-1 1-1 1zM181 112l1-3-1 3zM176 100a4 4 0 002 2c2-1 0-3 1-1a2 2 0 00-1 0l-2-1zM56 146c1 0 1 3 2 1l-2-1zM54 143v1h1v-1h-1zM55 142l1-2-1 2zM85 14l1 1-1-1zM100 20zM8 44H7c1 0 0 2 2 2l-1-2zM133 41c-2 0-2-3-3-2 1 1 2 3 3 2zM79 12c0 1-3 1-1 2l1-2zM82 12l1-1-2-1v2h1zM85 13l-2-1 2 1z' class='cls-1'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        content: "";
        position: absolute;
        bottom: 3rem;
        right: 0rem;
        width: 30%;
        height: 20%;
      }
    }

    @media (min-width: 46rem) {
      &:first-of-type {
        padding-top: 0;
        left: -5rem;

        &:before {
          top: -8rem;
          left: -11rem;
          width: 82%;
          height: 65%;
          z-index: 1;
        }
      }

      &:last-of-type {
        padding-top: 15rem;
        right: -5rem;

        &:after {
          bottom: -6rem;
          right: -2rem;
          width: 30%;
          height: 30%;
          z-index: 1;
        }
      }
    }
  `

  const IntroTop = styled.div`
    display: grid;
    grid-auto-flow: dense;
    grid-template-columns: repeat(6, 1fr);
    gap: 4rem 3rem;
    position: relative;
    z-index: 2;

    h1 {
      font-size: 1.85rem;
      margin: 0;
      grid-column-end: span 6;

      @media (min-width: 46rem) {
        font-size: 3.5rem;
        margin-bottom: 2rem;
        grid-column-end: span 4;
        grid-column-start: 3;
      }
    }

    h2 {
      font-size: 1.1rem;
      margin-bottom: 0;
      grid-column-end: span 6;

      @media (min-width: 46rem) {
        width: 100%;
        text-align: right;
        grid-column-end: span 4;
        grid-column-start: 3;
      }
    }
  `

  const IntroBottom = styled.div`
    display: grid;
    grid-auto-flow: dense;
    grid-template-columns: repeat(6, 1fr);
    gap: 1rem;

    @media (min-width: 46rem) {
      position: relative;
      z-index: 2;
      /* margin-bottom: 12rem; */
    }

    h3,
    p {
      grid-column-end: span 6;
    }

    @media (min-width: 46rem) {
      h3,
      p {
        grid-column-end: span 3;
      }

      h3 {
        font-size: 2.75rem;
      }

      p {
        margin-top: 10rem;
      }
    }
  `

  return (
    <IntroContainer>
      <IntroTop
        data-sal="fade-in"
        data-sal-delay="50"
        data-sal-duration="550"
        data-sal-easing="ease-in-out"
        dangerouslySetInnerHTML={{ __html: about.introduction }}
      />

      <ImagesWrapper>
        <Images>
          <ImageContainer
            data-sal="slide-up"
            data-sal-delay="50"
            data-sal-duration="500"
            data-sal-easing="ease-out-back"
          >
            <Img
              fluid={profilePhoto.childImageSharp.fluid}
              alt={profileAlt}
              title={profileAlt}
            />
          </ImageContainer>

          <ImageContainer
            data-sal="slide-up"
            data-sal-delay="100"
            data-sal-duration="250"
            data-sal-easing="ease-out-back"
          >
            <Img
              fluid={deskPhoto.childImageSharp.fluid}
              alt={deskAlt}
              title={deskAlt}
            />
          </ImageContainer>
        </Images>
      </ImagesWrapper>

      <IntroBottom
        dangerouslySetInnerHTML={{ __html: about.aboutOpeningSection }}
      />
    </IntroContainer>
  )
}

export default Intro
